import { Injectable } from '@angular/core';
import { DataService } from '../../services/data/data.service';
import { CommsService } from '../../services/comms/comms.service';
import { NoteService } from '../../services/note/note.service';
import { ConfigService } from '../../services/config/config.service';
import { DisplayService } from '../../services/display/display.service';
import _ from 'lodash';
import { EnvService } from '../../../config/env.service';

@Injectable()
export class AddonService {

	newContractorAddon = {
		'id': 'fieldid',
		'label': 'Field Label',
		'type': 'text',
		'permissions': {
			'admin': 'view',
			'sa': 'view',
			'pm': 'view',
			'sam': 'view',
			'srm': 'view',
			'contractor': 'view',
			'tra': 'view',
			'cca': 'view'
		},
		'table': false,
		'shortTable': false,
		'page': false,
		'required': false,
		'isUsed': false,
		'isSaved': false
	};

	constructor(
		private dataService: DataService,
		private commsService: CommsService,
		private noteService: NoteService,
		private configService: ConfigService,
		private displayService: DisplayService,
		private envService : EnvService
	) { }

	addContractorField() {
		const newField = _.cloneDeep(this.newContractorAddon);
		this.dataService.contractorAddonsEdited.push(newField);
	}

	deleteContractorAddon(field) {
		const self = this;
		this.commsService.deleteContractorAddon(field._id).subscribe((res) => {
			console.log('DELETE CONTRACTOR ADDON RES: ', res);
			this.loadContractorAddons();
		}, (err) => {
			if (err && err.error && err.error.message) {
				self.noteService.displayError(err.error.message);
			}
		});
	}

	updateUsedAddons(usedAddons) {
		this.dataService.contractorAddonsEdited = _.cloneDeep(this.dataService.contractorAddons);
		this.dataService.contractorAddonsEdited.forEach(addon => {
			if (usedAddons[addon.id] && usedAddons[addon.id] !== '') {
				addon.isUsed = true;
			}
		});
		console.log('UPDATED USED ADDONS', this.dataService.contractorAddonsEdited);
		this.saveContractorAddons();
	}

	resetContractorAddons() {
		this.dataService.contractorAddonsEdited = _.cloneDeep(this.dataService.contractorAddons);
	}

	hasContractorEdits() {
		const hasContractorEdits = !this.dataService.isEqual(this.dataService.contractorAddonsEdited, this.dataService.contractorAddons);
		return hasContractorEdits;
	}

	uniqueContractorEdits() {
		const self = this;
		let uniqueContractorEdits = this.emptyFieldCheck();
		this.dataService.contractorAddonsEdited.forEach(function(addon, i){
			const fieldId = addon.id;
			self.dataService.contractorAddonsEdited.forEach(function(dd, ii){
				if (dd.id === fieldId && i !== ii) {
					uniqueContractorEdits = false;
				}
			});
		});
		return uniqueContractorEdits;
	}

	emptyFieldCheck() {
		let emptyID = true;
		this.dataService.contractorAddonsEdited.forEach(function(addon){
			if (addon.id === '') {
				emptyID = false;
			}
		});
		return emptyID;
	}

	emptyLabelCheck() {
		let emptyID = true;
		this.dataService.contractorAddonsEdited.forEach(function(addon){
			if (addon.label === '') {
				emptyID = false;
			}
		});
		return emptyID;
	}

	loadContractorAddons() {
		const self = this;
		if (this.commsService.canAccess(this.envService.getEndPoints().addonsContractorEnd.access)) {
			this.displayService.startLoading();
			this.commsService.getContractorAddons().subscribe((res) => {
				this.displayService.endLoading();
				const jsonRes = res;
				console.log('LOAD CONTRACTOR ADDONS RES: ', jsonRes);
				const successData = jsonRes[self.configService.detailDataProp];
				successData.map(item => {
					item['isSaved'] = true;
				});
				this.dataService.updateContractorAddons(successData);
			}, (err) => {
				this.displayService.endLoading();
				if (err && err.error && err.error.message) {
					self.noteService.displayError(err.error.message);
				}
			});
		} else {
			console.log('LOAD CONTRACTOR ADDONS - NO ACCESS');
		}
	}

	saveContractorAddons() {
		const self = this;
		this.commsService.saveContractorAddons().subscribe((res) => {
			const jsonRes = res;
			console.log('SAVE CONTRACTOR ADDONS RES: ', jsonRes);
			this.loadContractorAddons();
			// const successData = jsonRes[self.configService.detailDataProp];
			// this.dataService.updateContractorAddons(successData);
		}, (err) => {
			if (err && err.error && err.error.message) {
				self.noteService.displayError(err.error.message);
			}
		});
	}

}
